// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 57) return "content/plugin-wells-vis/459c87e090c8e5f3adede618b24e2226.js";
	if (chunkId === 87) return "content/plugin-wells-vis/3523ce62e7c2160726ecc272996a7890.js";
	// return url for filenames based on template
	return undefined;
};